(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gateway"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupComparisonGroups() {
    document.querySelectorAll('.pot-compare__groups').forEach(function (group) {
      group.querySelectorAll('details.pot-compare__group').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          group.querySelectorAll('details.pot-compare__group[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function openFinderFromHash() {
    var match = window.location.hash.match(/^#finder-(\d+)$/);
    if (!match) return;

    var target = document.getElementById('finder-' + match[1]);
    if (!(target instanceof HTMLDetailsElement) || !target.classList.contains('gw-finder__door')) return;

    var group = target.closest('.gw-finder');
    if (group) {
      group.querySelectorAll('details.gw-finder__door[open]').forEach(function (door) {
        if (door !== target) door.open = false;
      });
    }

    target.open = true;
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ block: 'start' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupComparisonGroups();
      openFinderFromHash();
    }, { once: true });
  } else {
    setupComparisonGroups();
    openFinderFromHash();
  }

  window.addEventListener('hashchange', openFinderFromHash);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
